export const SET_DISTRIBUTIONS = 'setDistributions';
export const CLEAR_DISTRIBUTIONS = 'clearDistributions';
export const SET_DISTRIBUTION = 'setDistribution';
export const CLEAR_DISTRIBUTION = 'clearDistribution';
export const SET_VALIDITY_AT = 'setValidityAt';
export const SET_SCHEDULE_AT = 'setScheduleAt';
export const SET_WHATSAPP_INTEGRATIONS = 'setWhatsappIntegrations';
export const CLEAR_WHATSAPP_INTEGRATIONS = 'clearWhatsappIntegrations';
export const SET_REMINDER_AT = 'setReminderAt';
export const SET_QUERY_PARAMS = 'setQueryParams';
export const CLEAR_QUERY_PARAMS = 'clearQueryParams';
export const SET_WHATASTPP_INTEGRATION = 'setWhatsappIntegration';
export const SET_CHANNEL = 'setChannel';
export const SET_NAME = 'setName';
export const SET_IS_ANONYMOUS = 'setIsAnonymous';
export const SET_WHATSAPP_TEMPLATES = 'setWhatsappTemplates';
export const SET_MAPPING = 'setMapping';
export const SET_IMPORT_INVALID_LINES = 'setImportInvalidLines';
export const SET_DELIMITER = 'setDelimiter';
export const SET_CUSTOMER_SIZE = 'setCustomerSize';
export const SET_FILE = 'setFile';
export const SET_SCALE_LAYOUT = 'setScaleLayout';
export const SET_WHATSAPP_TEMPLATE_NAME = 'setWhatsappTemplateName';
export const SET_WHATSAPP_TEMPLATE_VARIABLES = 'setWhatsappTemplateVariables';
export const SET_WHATSAPP_TEMPLATE_SCREEN_VARIABLES = 'setWhatsappTemplateScreenVariables';
export const SET_WHATSAPP_TEMPLATE_LANGUAGE = 'setWhatsappTemplateLanguage';
export const SET_WHATSAPP_TEMPLATE_BODY = 'setWhatsappTemplateBody';
export const SET_WHATSAPP_REMINDER_TEMPLATE_NAME = 'setWhatsappReminderTemplateName';
export const SET_WHATSAPP_REMINDER_TEMPLATE_VARIABLES = 'setWhatsappReminderTemplateVariables';
export const SET_WHATSAPP_REMINDER_TEMPLATE_SCREEN_VARIABLES = 'setWhatsappReminderTemplateScreenVariables';
export const SET_WHATSAPP_REMINDER_TEMPLATE_LANGUAGE = 'setWhatsappReminderTemplateLanguage';
export const SET_WHATSAPP_REMINDER_TEMPLATE_BODY = 'setWhatsappReminderTemplateBody';
export const SET_DISTRIBUTION_CUSTOMERS = 'setDistributionCustomers';
export const SET_DISTRIBUTION_IMPORT_CONFIRMED = 'setDistributionImportConfirmed';
export const SET_DISTRIBUTION_IMPORTED = 'setDistributionImported';
export const CLEAR_DISTRIBUTION_CUSTOMERS = 'clearDistributionCustomers';
export const SET_TOTAL_DISTRIBUTION_CUSTOMERS = 'setTotalDistributionCustomers';
export const CLEAR_TOTAL_DISTRIBUTION_CUSTOMERS = 'clearTotalDistributionCustomers';
export const SET_LANGUAGE = 'setLanguage';
export const TOGGLE_PREVIEW = 'togglePreview';
export const SET_MESSAGE_TEMPLATE = 'setMessageTemplate';
export const SET_REMINDER_AT_FIELD = 'setReminderAtField';
export const RESET_REMINDER_AT_FIELDS = 'resetReminderAtFields';
